















































































import {
    BaseView,
    Component,
    ComponentStyle,
    ComponentStyleDefinition,
    FlowStep,
    FlowStepSubmitStatus,
    FlowStepType,
    InjectComponent,
    ModelProp,
    Prop,
    QuestionType,
    VueComponent
} from "@zoovu/runner-browser-api";

@Component({})
    export default class PageView extends BaseView {

        @ComponentStyle()
        componentStyle: ComponentStyleDefinition;

        @ModelProp()
        flowStep: FlowStep;

        @Prop({default: false})
        showHeadline: boolean;

        @Prop({default: false})
        lastFlowStep: boolean;

        @InjectComponent("ChoiceQuestionView")
        choiceQuestionView: VueComponent;

        @InjectComponent("DropDownQuestionView")
        dropDownQuestionView: VueComponent;

        @InjectComponent("RangeQuestionView")
        rangeQuestionView: VueComponent;

        @InjectComponent("SliderQuestionView")
        sliderQuestionView: VueComponent;

        @InjectComponent("TextQuestionView")
        textQuestionView: VueComponent;

        @InjectComponent("LongTextQuestionView")
        longTextQuestionView: VueComponent;

        @InjectComponent("FileUploadQuestionView")
        fileUploadQuestionView: VueComponent;

        get QuestionType(): typeof QuestionType {
            return QuestionType;
        }

        get submitIsInProgress(): boolean {
            return this.flowStep.submitStatus === FlowStepSubmitStatus.SUBMIT_IN_PROGRESS;
        }

        get flowStepIsOfTypeLead(): boolean {
            return this.flowStep.type === FlowStepType.LEAD;
        }

        get rootElementClass(): string {
            return "page-wrapper";
        }

        get isFlowStepSubmitted(): boolean {
            return this.flowStep.submitStatus === FlowStepSubmitStatus.SUBMITTED;
        }

        isFirstQuestion(index) {
            return index === 0;
        }

        isLastQuestion(index) {
            return index === this.flowStep.questions.length - 1;
        }
    }
